import React, { useState } from "react";
import { connect, useSelector } from "react-redux";
import { login } from "actions/auth";
import { useCookies } from 'react-cookie';
import { Redirect } from "react-router";
import { CircularProgress } from "@mui/material";
// import { handleCookie, fetchVersion } from "./utils";

//CSS styling for the current component
// Styles for the overlay and spinner
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
  flexDirection: "column",
};

const textStyle = {
  color: "White",
  fontSize: "1.5rem",
  marginBottom: "1rem",
  textAlign: "center",
};

export default connect(({ isLoading }) => ({ isLoading }), { login })(props => {

  const isAuthUser = useSelector(state => state.isAuthUser);
  const AccessToken = useSelector(state => state.accessToken);
  const myRole = useSelector(state => state.role);
  const isAccounting = (myRole === "accounting") ? true : false;
  const isSalesOperator = (myRole === "salesoperator") ? true : false;
  const isSalesAdmin = (myRole === "salesadmin") ? true : false;
  const isSupport = (myRole === "support") ? true : false;
  const isError = useSelector(state => state.isError);
  const [cookie, setCookie] = useCookies(['token']);
  const [processing, setProcessing] = useState(true);

  const urlParams = new URLSearchParams(window.location.search);
  const authCode = urlParams.get('code');

  if (isAuthUser) {
    // fetchVersion();
    // handleCookie(setCookie, AccessToken);
    if (isAccounting) {
      return <Redirect to="/accounting/customers/list" />;
    } else if (isSupport) {
      return <Redirect to="/support/customers/list" />;
    } else if (isSalesAdmin) {
      return <Redirect to="/salesadmin/customers/list" />;
    } else if (isSalesOperator) {
      return <Redirect to="/salesoperator/customers/list" />;
    } else {
      return <Redirect to="/login" />;
    }
  }

  if (authCode) {
    console.log("AuthCode = ", authCode);
    // Retrieve the stored endpoints from localStorage
    const emailAddr = localStorage.getItem('emailAddr');
    const ssoDataJson = localStorage.getItem('sso_data')

    if (emailAddr && ssoDataJson) {
      let ssoData = JSON.parse(ssoDataJson);
      ssoData["auth_code"] = authCode;
      ssoData["redirect_uri"] = `${window.location.origin}/ssoCallback`;
      let jsonPostMsg = {
        'email': emailAddr,
        'sso_data': JSON.stringify(ssoData)
      };
      console.log("jsonPostMsg login api = ", jsonPostMsg);
      localStorage.setItem("ssoLoginRequested", true);
      props.login(jsonPostMsg);
    } else {
      console.log("SSO Auth Code received but no required data in the storage!");
    }
  } else if ( (localStorage.getItem("ssoLoginRequested") === null) || isError ) {
    console.log("No authcode found.");
    return <Redirect to={{
      pathname: '/login'
    }} />;
  }
  localStorage.removeItem('sso_data');
  localStorage.removeItem('emailAddr');

  return (
    <>
      {/* Overlay with spinner and centered text */}
      {processing && (
        <div style={overlayStyle}>
          <h1 style={textStyle}>Please wait while you are being authenticated.</h1>
          <CircularProgress color="secondary" size="4rem" />
        </div>
      )}
    </>
  )
});
